export default {
  isRegisteredPicture: state => {
    return state.pictureSrc !== null ? "有" : "無";
  }
};
